import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import './Result.css';

function ViewExams() {
    const { email } = useParams();
    const [exams, setExams] = useState([]);
    const navigate = useNavigate();
    const config=require( '../../config.js');
    useEffect(() => {
        fetch(config.env.API_BASE_URL+'/api/results/'+email+'/exams', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        })
            .then(response => response.json())
            .then(data => setExams(data))
            .catch(error => console.error('Error fetching exams:', error));
    }, [email]);

    const GotoViewAnswer = (result) => {
        navigate("/take-assessment", {
          state: {
            examName: result.examName,
            examCategory: result.examCategory,
            isMSS: result.isMSS,
            assessmentId: result.assessmentId._id,
            disabled: true,
            edit: true,
            resultId: result._id,
          },
        });
      };

    return (
        <div>
            <div className='mt-5 Crud-main-container container'>
                <table className="table Crud-main container">
                    <thead>
                        <tr className="Crud-thead-wrapper">
                            <th scope="col" className='text-start'>Name</th>
                            <th scope="col">Category</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {exams.map((exam, index) => (
                            <tr key={index}>
                                <td className='text-start'>{exam.examName}</td>
                                <td>{exam.examCategory}</td>
                                <td className='view-exam-icon' onClick={() => GotoViewAnswer(exam)}>
                                    <FontAwesomeIcon icon={faEye} /> View Answer
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ViewExams;
